document.addEventListener("DOMContentLoaded", function() {

  // ==========================
  // HELPERS
  // ==========================
  const safeStorage = {
    get(key) {
      try { return JSON.parse(localStorage.getItem(key)) || []; }
      catch { return []; }
    },
    set(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); }
      catch { console.warn("Safari blocked localStorage.setItem"); }
    }
  };

  function openPopup(id) {
    const popup = document.getElementById(id);
    if (popup) {
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  }

  function closePopup(id) {
    const popup = document.getElementById(id);
    if (popup) {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }
  }

  function isFavorite(productId) {
    function safeGetFavorites() {
      try {
        return JSON.parse(localStorage.getItem("bundleFavorites")) || [];
      } catch (e) {
        console.warn("Safari blocked localStorage");
        return [];
      }
    }
    const favorites = safeGetFavorites();
    return favorites.some(item => item.productId === productId);
  }

  function saveFavorite(variantId, productId, title, media, collectionId, collectionTitle) {
    let favorites = JSON.parse(localStorage.getItem("bundleFavorites")) || [];
    if (!favorites.some(item => item.productId === productId)) {
      favorites.push({ variantId, productId, title, media, collectionId, collectionTitle });
      safeStorage.set("bundleFavorites", favorites);
      updateHeartStates();
      loadFavorites();
    }
  }

  function removeFavorite(productId) {
    let favorites = JSON.parse(localStorage.getItem("bundleFavorites")) || [];
    favorites = favorites.filter(item => item.productId !== productId);
    safeStorage.set("bundleFavorites", favorites);
    updateHeartStates();
    loadFavorites();
  }

  function updateHeartStates() {
    document.querySelectorAll(".favorite-btn").forEach(btn => {
      const id = btn.getAttribute("data-product-id");
      if (id && isFavorite(id)) btn.classList.add("favorited");
      else btn.classList.remove("favorited");
    });
  }

  function loadFavorites() {
    const favGrid = document.querySelector(".favorite-grid");
    if (!favGrid) return;

    function safeGetFavorites() {
      try {
        return JSON.parse(localStorage.getItem("bundleFavorites")) || [];
      } catch (e) {
        console.warn("Safari blocked localStorage");
        return [];
      }
    }
    const favorites = safeGetFavorites();

    if (favorites.length === 0) {
      favGrid.innerHTML = '<p class="bundle-collection__empty">No favorite products yet.</p>';
      return;
    }

    favGrid.innerHTML = "";
    favorites.forEach(item => {
      favGrid.insertAdjacentHTML("beforeend", `
        <div class="bundle-collection__item" 
            data-product-id="${item.productId}" 
            data-variant-id="${item.variantId}">
          <div class="bundle-collection__image"
            data-variant-id="${item.variantId}"
            data-product-id="${item.productId}"
            data-collection-id="${item.collectionId || ''}"
            data-collection-title="${item.collectionTitle || ''}"
            data-product-title="${item.title}"
            data-product-media="${item.media}">
            <img src="${item.media}" alt="${item.title}" class="bundle-collection__img">
          </div>
          <h3 class="bundle-collection__title">${item.title}</h3>
          <button class="remove-favorite" data-remove-id="${item.productId}">Remove</button>
        </div>
      `);
    });
  }

  function updateFavoriteButtonState(btn, id) {
    if (isFavorite(id)) {
      btn.classList.add("favorited");
      btn.innerHTML = `
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="pink" >
        <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
      `;
    } else {
      btn.classList.remove("favorited");
      btn.innerHTML = `
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
        <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
      `;
    }
  }

  // ==========================
  // TAB SWITCHING
  // ==========================
  document.querySelectorAll(".bundle-tab").forEach(tab => {
    tab.addEventListener("click", function() {
      const target = this.getAttribute("data-tab");
      document.querySelectorAll(".bundle-tab, .bundle-tab-content").forEach(el => el.classList.remove("active"));
      this.classList.add("active");
      document.querySelector(`[data-content='${target}']`)?.classList.add("active");
    });
  });

  // ==========================
  // CLICK HANDLERS
  // ==========================
  let selectedSlot = null;

  // --- PREVENT FAVORITE BUTTON FROM TRIGGERING QUICK VIEW ---
  document.addEventListener("click", function(e) {
    const favBtn = e.target.closest(".favorite-btn");
    if (!favBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = favBtn.dataset.variantId || "";
    const productId = favBtn.dataset.productId || "";
    const title = favBtn.dataset.productTitle || "";
    const media = favBtn.dataset.productMedia || "";
    const collectionId = favBtn.dataset.collectionId || "";
    const collectionTitle = favBtn.dataset.collectionTitle || "";

    if (isFavorite(productId)) {
      removeFavorite(productId);
    } else {
      saveFavorite(variantId, productId, title, media, collectionId, collectionTitle);
    }

    updateFavoriteButtonState(favBtn, productId);
  }, true);
  // <-- notice the 'true' capture phase listener


  document.addEventListener("click", function(e) {
    const target = e.target;
    

    if (target.closest(".add-btn")) {
      const addBtn = target.closest(".add-btn");
      e.preventDefault();
      e.stopPropagation();

      const variantId = addBtn.dataset.variantId;
      const productId = addBtn.dataset.productId;
      const collectionId = addBtn.dataset.collectionId;
      const collectionTitle = addBtn.dataset.collectionTitle;
      const title = addBtn.dataset.productTitle;
      const img = addBtn.dataset.productMedia;

      let targetSlot =
        selectedSlot ||
        document
          .querySelector(".bundle-product img[src*='placeholder']")
          ?.closest(".bundle-product");

      if (targetSlot) {
        targetSlot.dataset.id = variantId;
        targetSlot.dataset.product = productId;
        targetSlot.dataset.collection = collectionId;
        targetSlot.dataset.collectionTitle = collectionTitle;
        targetSlot.innerHTML = `
          <div class="bundle-content">
            <img src="${img}" alt="${title}">
            <p>${title}</p>
            <button class="remove-btn" aria-label="Remove product">
              <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
                <rect width="41" height="42" rx="7.02" fill="white"/>
                <path d="M26.985 26.9831L21.0882 21.0863L15.1914 15.1895M26.985 15.1895L15.1914 26.9831" stroke="black" stroke-width="1.4742" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        `;
      }

      closePopup("bundle-collection-popup");
      selectedSlot = null;
      return; // ⛔ Stop here — don’t let Quick View logic below run
    }
    if (target.closest(".bundle-collection__image")) {
  const imgContainer = target.closest(".bundle-collection__image");
  e.preventDefault();
  e.stopPropagation();

  const variantId = imgContainer.dataset.variantId;
  const productId = imgContainer.dataset.productId;
  const collectionId = imgContainer.dataset.collectionId;
  const collectionTitle = imgContainer.dataset.collectionTitle;
  const title = imgContainer.dataset.productTitle;
  const img = imgContainer.querySelector("img")?.src || "";

  let targetSlot =
    selectedSlot ||
    document
      .querySelector(".bundle-product img[src*='placeholder']")
      ?.closest(".bundle-product");

  if (targetSlot) {
    targetSlot.dataset.id = variantId;
    targetSlot.dataset.product = productId;
    targetSlot.dataset.collection = collectionId;
    targetSlot.dataset.collectionTitle = collectionTitle;
    targetSlot.innerHTML = `
      <div class="bundle-content">
        <img src="${img}" alt="${title}">
        <p>${title}</p>
        <button class="remove-btn" aria-label="Remove product">
          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
            <rect width="41" height="42" rx="7.02" fill="white"/>
            <path d="M26.985 26.9831L21.0882 21.0863L15.1914 15.1895M26.985 15.1895L15.1914 26.9831" stroke="black" stroke-width="1.4742" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `;
  }

  closePopup("bundle-collection-popup");
    selectedSlot = null;
    return;
  }
    // --- OPEN QUICK VIEW ---
    if (
      target.classList.contains("quick-view-btn")
    ) {
      const trigger = target.closest(".quick-view-btn");
      const variantId = trigger.dataset.variantId;
      const productId = trigger.dataset.productId;
      const collectionId = trigger.dataset.collectionId;
      const collectionTitle = trigger.dataset.collectionTitle;
      const title = trigger.dataset.productTitle;
      const media = trigger.dataset.productMedia;

      const quickview = document.getElementById("quickview-popup");
      quickview.querySelector(".quickview--title").textContent = title;
      // --- DISPLAY ALL PRODUCT MEDIA WITH SWIPER ---
      const mediaArray = media.split(",");

      // Insert Swiper HTML structure
      quickview.querySelector(".quickview__media").innerHTML = `
        <div class="swiper quickview-swiper">
          <button class="favorite-btn quickview__fav"
            data-product-id=""
            data-product-title=""
            data-product-media="">
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
            <path d="M4.42602 12.3115L12 19.8854L19.574 12.3115C21.4753 10.4101 21.4753 7.32738 19.574 5.42602C17.6726 3.52466 14.5899 3.52466 12.6885 5.42602L12 6.11456L11.3115 5.42602C9.4101 3.52466 6.32738 3.52466 4.42602 5.42602C2.52466 7.32738 2.52466 10.4101 4.42602 12.3115Z" stroke="#000000" stroke-width="1.2" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="swiper-wrapper">
            ${mediaArray
              .map((url) => {
                const cleanUrl = url.trim();

                // Build srcset with typical responsive widths
                const srcset = `
                  ${cleanUrl.replace(/width=\d+/, "width=300")} 300w,
                  ${cleanUrl.replace(/width=\d+/, "width=600")} 600w,
                  ${cleanUrl.replace(/width=\d+/, "width=900")} 900w,
                  ${cleanUrl.replace(/width=\d+/, "width=1200")} 1200w
                `.trim();

                return `
                  <div class="swiper-slide">
                    <img 
                      src="${cleanUrl}"
                      srcset="${srcset}"
                      sizes="(max-width: 768px) 100vw, 600px"
                      alt="${title}"
                      loading="lazy"
                    >
                  </div>
                `;
              })
              .join("")}
          </div>
          <!-- Navigation Arrows -->
          <div class="quickview-navigation">
            <div class="quickview-prev">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <circle cx="17.0356" cy="17.0352" r="16.4674" transform="rotate(180 17.0356 17.0352)" fill="white" stroke="black" stroke-width="1.13568"/>
                <path d="M13.0239 16.431C12.6912 16.7636 12.6912 17.3029 13.0239 17.6356L18.4444 23.0561C18.7771 23.3888 19.3164 23.3888 19.649 23.0561C19.9816 22.7235 19.9816 22.1842 19.649 21.8516L14.8307 17.0333L19.649 12.215C19.9816 11.8824 19.9816 11.3431 19.649 11.0104C19.3164 10.6778 18.7771 10.6778 18.4444 11.0104L13.0239 16.431ZM13.6263 17.0333L13.6263 16.1815L13.6262 16.1815L13.6262 17.0333L13.6262 17.8851L13.6263 17.8851L13.6263 17.0333Z" fill="black"/>
              </svg>
            </div>
            <div class="quickview-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                <circle cx="17.0356" cy="17.0352" r="16.4674" fill="white" stroke="black" stroke-width="1.13568"/>
                <path d="M21.0473 17.6394C21.38 17.3068 21.38 16.7675 21.0473 16.4348L15.6268 11.0143C15.2941 10.6816 14.7548 10.6816 14.4222 11.0143C14.0896 11.3469 14.0896 11.8862 14.4222 12.2188L19.2405 17.0371L14.4222 21.8554C14.0896 22.188 14.0896 22.7273 14.4222 23.06C14.7548 23.3926 15.2941 23.3926 15.6268 23.06L21.0473 17.6394ZM20.445 17.0371L20.445 17.8889L20.4451 17.8889L20.4451 17.0371L20.4451 16.1853L20.445 16.1853L20.445 17.0371Z" fill="black"/>
              </svg>
            </div>
          </div>
          <!-- Pagination Dots -->
          
        </div>
        <div class="quick-view-pagination swiper-pagination"></div>
      `;

      if (window.quickviewSwiper) {
        window.quickviewSwiper.destroy(true, true);
      }

      window.quickviewSwiper = new Swiper(".quickview-swiper", {
        speed: 600,
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: ".bundle-popup__content .quickview-next",
          prevEl: ".bundle-popup__content .quickview-prev",
        },
        pagination: {
          el: ".bundle-popup__content .swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
      });



      const favBtn = quickview.querySelector(".quickview__fav");
      const selectBtn = quickview.querySelector(".quickview__select");

      // ✅ Ensure all dataset values are applied
      favBtn.dataset.productId = productId;
      favBtn.dataset.productTitle = title;
      favBtn.dataset.productMedia = media;
      favBtn.dataset.variantId = variantId;
      favBtn.dataset.collectionId = collectionId;
      favBtn.dataset.collectionTitle = collectionTitle;

      selectBtn.dataset.variantId = variantId;
      selectBtn.dataset.productTitle = title;
      selectBtn.dataset.collectionId = collectionId;
      selectBtn.dataset.collectionTitle = collectionTitle;
      selectBtn.dataset.productMedia = media;
      selectBtn.dataset.productId = productId;

      updateFavoriteButtonState(favBtn, productId);
      openPopup("quickview-popup");

      return;
    }

    // --- FAVORITE TOGGLE ---
    if (target.classList.contains("favorite-btn")) {
      const id = target.dataset.productId;
      const title = target.dataset.productTitle;
      const media = target.dataset.productMedia;

      if (isFavorite(id)) removeFavorite(id);
      else saveFavorite(id, title, media);

      if (target.classList.contains("quickview__fav")) updateFavoriteButtonState(target, id);
      return;
    }

    // --- REMOVE FAVORITE ---
    if (target.classList.contains("remove-favorite")) {
      const id = target.dataset.removeId;
      removeFavorite(id);
      return;
    }

    // --- SELECT PRODUCT (FROM QUICKVIEW) ---
    if (target.classList.contains("quickview__select")) {
      const variantId = target.dataset.variantId;
      const productId = target.dataset.productId;
      const collectionId = target.dataset.collectionId;
      const collectionTitle = target.dataset.collectionTitle;
      const title = target.dataset.productTitle;
      const img = target.dataset.productMedia;

      let targetSlot = selectedSlot || document.querySelector(".bundle-product img[src*='placeholder']")?.closest(".bundle-product");
      if (targetSlot) {
        targetSlot.dataset.id = variantId;
        targetSlot.dataset.product = productId;
        targetSlot.dataset.collection = collectionId;
        targetSlot.dataset.collectionTitle = collectionTitle;
        targetSlot.innerHTML = `
          <div class="bundle-content">
            <img src="${img}" alt="${title}">
            <p>${title}</p>
            <button class="remove-btn" aria-label="Remove product">
              <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
                <rect width="41" height="42" rx="7.02" fill="white"/>
                <path d="M26.985 26.9831L21.0882 21.0863L15.1914 15.1895M26.985 15.1895L15.1914 26.9831" stroke="black" stroke-width="1.4742" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        `;
      }
      closePopup("quickview-popup");
      closePopup("bundle-collection-popup");
      selectedSlot = null;
      return;
    }

    // --- REMOVE SLOT ---
    if (target.classList.contains("remove-btn")) {
      const slot = target.closest(".bundle-product");
      const allSlots = Array.from(slot.parentElement.querySelectorAll(".bundle-product"));
      const slotNumber = allSlots.indexOf(slot) + 1;
      slot.dataset.id = "";
      slot.dataset.product = "";
      slot.dataset.collection = "";
      slot.dataset.collectionTitle = "";
      slot.innerHTML = `
        <div class="empty--slot">
          <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="59" height="59" rx="29.5" fill="white"/>
            <path d="M36.5676 29.6197H29.6178M29.6178 29.6197H22.668M29.6178 29.6197V22.6699M29.6178 29.6197V36.5695" stroke="black" stroke-width="1.73745" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p>Design ${slotNumber}</p>
      `;
      return;
    }

    // --- OPEN PRODUCT SELECT POPUP ---
    if (target.closest(".bundle-product") && !target.classList.contains("remove-btn")) {
      selectedSlot = target.closest(".bundle-product");

      // Get all slots in the same container
      const allSlots = Array.from(selectedSlot.parentElement.querySelectorAll(".bundle-product"));
      const slotNumber = allSlots.indexOf(selectedSlot) + 1;

      // Update popup title dynamically
      const popupTitle = document.querySelector("#bundle-collection-popup .bundle-popup__title");
      if (popupTitle) {
        popupTitle.textContent = `Select Colour ${slotNumber}`;
      }

      // Open popup
      openPopup("bundle-collection-popup");
      return;
    }

    // --- CLOSE POPUP CLICK ON OVERLAY AND CLOSE BUTTON ---
    if (
      target.classList.contains("bundle-popup-overlay") ||
      target.closest(".bundle-popup__close")
    ) {
      const popupToClose = target.closest(".bundle-popup-overlay") 
        || document.getElementById(target.closest(".bundle-popup__close")?.dataset.popupClose);

      if (popupToClose) {
        popupToClose.classList.remove("active");
        document.body.style.overflow = "";

        // Reset title if it’s the main bundle popup
        if (popupToClose.id === "bundle-collection-popup") {
          const popupTitle = popupToClose.querySelector(".bundle-popup__title");
          if (popupTitle) popupTitle.textContent = "Select Colour 1";
        }
      }
    }
  });

  // ==========================
  // INIT
  // ==========================
  loadFavorites();
  setTimeout(updateHeartStates, 100);



  });